import { NativeContainerElement390em0tm6yzca as NativeContainerElement } from '../NativeContainerElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { nativeSwapd14jid0qtx03 as nativeSwap } from './SwapView.commonHtml.js.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SwapViewClass;
function SwapView() {
  if (SwapViewClass === VOID) {
    class $ extends NativeContainerElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-stack');
        // Inline function 'com.lightningkite.kiteui.views.overflowX' call
        this.native_1.style_1.native_1.overflowX = 'hidden';
        // Inline function 'com.lightningkite.kiteui.views.overflowY' call
        this.native_1.style_1.native_1.overflowY = 'hidden';
        this.previousLast_1 = null;
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this;
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
      swap_26x94b_k$(transition, createNewView) {
        nativeSwap(this, transition, createNewView);
      }
    }
    initMetadataForClass($, 'SwapView');
    SwapViewClass = $;
  }
  return SwapViewClass;
}
//region block: exports
export {
  SwapView as SwapView1526g6cz7z56r,
};
//endregion

//# sourceMappingURL=SwapView.commonHtml.mjs.map
